<div *ngIf="userLoggedIn" class="row no-gutters">
  <div class="row col justify-content-end ">
    <acs-form-link
    class="mb-1"
    *ngFor="let formId of selectedFormIds; trackBy: getIdentifierForIterableItem"
    [formId]="formId"
    [showIcon]="true"
    [useLongName]="useLongName"></acs-form-link>
  </div>

  <button [matMenuTriggerFor]="userOptionsMenu"
          aria-label="User Options"
          class="pb-1 ml-3 toolbar-button icon-only last mat-primary"
          mat-icon-button>
    <mat-icon fontIcon="fa-user" class="fa" aria-label="user icon"></mat-icon>
  </button>
  <mat-menu #userOptionsMenu="matMenu">
    <button mat-menu-item (click)="showSettings()">
      <mat-icon fontIcon="fa-cog" class="fa fa-fw" aria-label="Change report settings"></mat-icon>
      Settings
    </button>
    <button mat-menu-item class="toolbar-button" *ngIf="userLoggedIn" (click)="logout()">
      <mat-icon fontIcon="fa-power-off" class="fa fa-fw" aria-label="Logout"></mat-icon>
      Logoff
    </button>
  </mat-menu>
</div>
